import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import '../css/wa.css';
import '../css/monthly.css';
import SunEditor from 'suneditor-react';
import axios from 'axios';


function Form() {
    const [selectedOption, setSelectedOption] = useState("");
    const [identifier, setIdentifier] = useState("");


    const [editorData, setEditorData] = useState('');
    const [email, setEmail] = useState('');
    
    const location = useLocation();
    
    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const type = params.get("type");
        const code = params.get("code");

        if (type) {
            setSelectedOption(type);
        }

        if (code) {
            setIdentifier(code);
        }
    }, [location]);



    const handleEditorChange = (content) => {
        setEditorData(content);
    };
    const submit = async () => {
        const content = editorData;
        const key = identifier;
        
        try {
            const { data } = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/form/submit`, { content, key, email });
            alert('접수되었습니다.');
            window.location.href = '/';
        } catch (error) {
            console.error("Err", error);
        }
    };
    
    
    return (
        <>
            <div className="mt-center">
                <div className="mt-main">
                    <h2>문의와 신고</h2>
                    <div className="form-flex">
                        <select value={selectedOption} onChange={(e) => setSelectedOption(e.target.value)} className="select">
                            <option value="inquire">문의</option>
                            <option value="report">신고</option>
                            <option value="expert">익스퍼트 신청</option>
                        </select>
                        <input
                            placeholder="식별자"
                            value={identifier}
                            onChange={(e) => setIdentifier(e.target.value)}
                        />
                    </div>

                    <div className="form-flex">
                        <SunEditor
                            mode="inline"
                            onChange={handleEditorChange}
                            setContents={editorData}
                            placeholder="문의/신고 내용 입력(사진 첨부 가능)"
                            lang="ko"
                            setOptions={{
                                height: '400px',
                                maxHeight: '550px',
                                placeholder: '여기에 내용을 입력해주세요...',
                                buttonList: [
                                    ['undo', 'redo'],
                                    ['formatBlock'],
                                    ['bold', 'italic', 'underline', 'strike', 'fontColor', 'hiliteColor'],
                                    ['align', 'horizontalRule'],
                                    ['outdent', 'indent'],
                                    ['table', 'link', 'image'],
                                ],
                                font: ['Wanted Sans', 'Arial', 'Comic Sans MS', 'Courier New', 'Georgia', 'Tahoma', 'Verdana'],
                                fontSize: [8, 10, 12, 14, 16, 18, 20, 24, 28, 32, 36],
                                defaultStyle: 'font-size: 16px; font-family: Arial, sans-serif;',
                            }}
                        />
                    </div>
                    <div className="form-flex">
                        <input
                            placeholder="답변/안내 이메일"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                        />
                    </div>
                    
                    <button className='btn-expert' onClick={submit}>접수하기</button>
                </div>
            </div>
        </>
    );
}

export default Form;
